export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#1a2b4a] text-white py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-10 gap-12 mb-12">
          {/* Left Column */}
          <div className="md:col-span-4 space-y-4">
            <h3 className="text-2xl font-semibold" style={{ fontFamily: 'Crimson Text, serif' }}>
              Jerilyn Emerson
            </h3>
            <p className="text-white/70 text-sm">
              Strategic guidance for mission-driven leaders
            </p>
            <div className="w-16 h-0.5 bg-[#2d9b9b]"></div>
            <p className="text-white/60 text-sm">
              Based in Washington, DC Area | Serving organizations nationwide
            </p>
          </div>

          {/* Middle Column */}
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-base font-semibold">Connect</h4>
            <div className="flex flex-col gap-3">
              <a
                href="https://www.linkedin.com/in/jerilyn-emerson/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-[#2d9b9b] transition-colors text-sm flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-linkedin-line"></i>
                LinkedIn
              </a>
              <a
                href="mailto:jerilyn@jerilynemerson.com"
                className="text-white/80 hover:text-[#2d9b9b] transition-colors text-sm flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                Email
              </a>
            </div>
          </div>

          {/* Right Column */}
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-base font-semibold">Navigate</h4>
            <div className="flex flex-col gap-3">
              <button
                onClick={() => scrollToSection('about')}
                className="text-white/80 hover:text-[#2d9b9b] hover:underline transition-colors text-sm text-left cursor-pointer whitespace-nowrap"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-white/80 hover:text-[#2d9b9b] hover:underline transition-colors text-sm text-left cursor-pointer whitespace-nowrap"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white/80 hover:text-[#2d9b9b] hover:underline transition-colors text-sm text-left cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[#2d9b9b]/30">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <p>&copy; 2025 Jerilyn Emerson Consulting</p>
            <a href="/privacy-policy" className="hover:text-[#2d9b9b] transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}